export function ComingSoonPage({ title }: { title: string }) {
  return (
    <div className="mx-auto max-w-3xl px-6 py-12 text-center">
      <h1 className="mb-2 text-2xl font-bold">{title}</h1>
      <p className="text-fg-3">
        This screen ports from the prototype in Phase 1 — coming next.
      </p>
    </div>
  );
}
